import React, { useState, useEffect } from 'react';
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Heart, MessageCircle, Bookmark, Send, MapPin, Eye } from 'lucide-react';
import { toast } from "sonner";
import { agentAdvancerMain } from '../images';

// Mock data for agency posts
const mockPosts = [
  {
    id: 1,
    agenzia: {
      nome: "Immobiliare Milano Centro",
      logo: agentAdvancerMain,
      citta: "Milano",
      zona: "Centro"
    },
    contenuto: {
      testo: "🏢 Siamo alla ricerca di 3 nuovi agenti per il nostro team! Se hai passione per l'immobiliare e vuoi crescere con noi, questa è la tua opportunità. Offriamo formazione completa e provvigioni competitive! #recruiting #team #nuoveopportunità",
      immagine: "https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=800&h=600&fit=crop",
      video: null
    },
    hashtags: ["#recruiting", "#team", "#nuoveopportunità"],
    statistiche: {
      visualizzazioni: 234,
      likes: 18,
      commenti: 5,
      salvati: 12
    },
    timestamp: "2h fa",
    liked: false,
    saved: false
  },
  {
    id: 2,
    agenzia: {
      nome: "Casa Bella Roma",
      logo: agentAdvancerMain,
      citta: "Roma",
      zona: "Parioli"
    },
    contenuto: {
      testo: "💼 La nostra squadra sta crescendo! Cerchiamo agenti motivati per la zona Parioli. Esperienza preferibile ma non indispensabile - formiamo noi i migliori talenti! #career #formazione #roma",
      immagine: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
      video: null
    },
    hashtags: ["#career", "#formazione", "#roma"],
    statistiche: {
      visualizzazioni: 189,
      likes: 24,
      commenti: 8,
      salvati: 6
    },
    timestamp: "4h fa",
    liked: true,
    saved: false
  },
  {
    id: 3,
    agenzia: {
      nome: "Venezia Properties",
      logo: agentAdvancerMain,
      citta: "Venezia",
      zona: "Centro Storico"
    },
    contenuto: {
      testo: "🌟 Unisciti al team leader nel mercato immobiliare veneziano! Stiamo selezionando 2 agenti per espandere la nostra presenza. Ottime opportunità di guadagno in una delle città più belle al mondo! #venezia #opportunità #leadership",
      immagine: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=800&h=600&fit=crop",
      video: null
    },
    hashtags: ["#venezia", "#opportunità", "#leadership"],
    statistiche: {
      visualizzazioni: 156,
      likes: 31,
      commenti: 12,
      salvati: 18
    },
    timestamp: "6h fa",
    liked: false,
    saved: true
  },
  {
    id: 4,
    agenzia: {
      nome: "Torino Immobiliare Plus",
      logo: agentAdvancerMain,
      citta: "Torino",
      zona: "San Salvario"
    },
    contenuto: {
      testo: "📈 Record di vendite quest'anno! Il nostro team continua a crescere e cerchiamo nuovi talenti. Se credi nelle tue capacità e vuoi guadagnare tanto quanto meriti, scrivici! #successo #vendite #guadagni",
      immagine: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=600&fit=crop",
      video: null
    },
    hashtags: ["#successo", "#vendite", "#guadagni"],
    statistiche: {
      visualizzazioni: 298,
      likes: 45,
      commenti: 15,
      salvati: 22
    },
    timestamp: "8h fa",
    liked: true,
    saved: false
  },
  {
    id: 5,
    agenzia: {
      nome: "Napoli Centro Immobiliare",
      logo: agentAdvancerMain,
      citta: "Napoli",
      zona: "Vomero"
    },
    contenuto: {
      testo: "🔥 OPPORTUNITÀ IMPERDIBILE! Apriamo una nuova filiale e cerchiamo il team di lancio. Primi 5 agenti selezionati avranno condizioni speciali e bonus di ingresso. Non perdere tempo! #nuovafiliale #bonus #napoli",
      immagine: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop",
      video: null
    },
    hashtags: ["#nuovafiliale", "#bonus", "#napoli"],
    statistiche: {
      visualizzazioni: 412,
      likes: 67,
      commenti: 28,
      salvati: 35
    },
    timestamp: "1g fa",
    liked: false,
    saved: true
  }
];

const FeedAgenzie = () => {
  const [posts, setPosts] = useState(mockPosts);
  const [loading, setLoading] = useState(false);

  const handleLike = (postId) => {
    setPosts(prevPosts =>
      prevPosts.map(post =>
        post.id === postId
          ? {
              ...post,
              liked: !post.liked,
              statistiche: {
                ...post.statistiche,
                likes: post.liked 
                  ? post.statistiche.likes - 1 
                  : post.statistiche.likes + 1
              }
            }
          : post
      )
    );
    toast.success(posts.find(p => p.id === postId)?.liked ? 'Like rimosso' : 'Mi piace aggiunto!');
  };

  const handleSave = (postId) => {
    setPosts(prevPosts =>
      prevPosts.map(post =>
        post.id === postId
          ? {
              ...post,
              saved: !post.saved,
              statistiche: {
                ...post.statistiche,
                salvati: post.saved 
                  ? post.statistiche.salvati - 1 
                  : post.statistiche.salvati + 1
              }
            }
          : post
      )
    );
    toast.success(posts.find(p => p.id === postId)?.saved ? 'Rimosso dai salvati' : 'Post salvato!');
  };

  const handleContact = (agenciaName) => {
    toast.success(`Contattando ${agenciaName}...`);
  };

  const handleApply = (agenciaName) => {
    toast.success(`Candidatura inviata a ${agenciaName}!`);
  };

  const renderHashtags = (hashtags) => {
    return hashtags.map((tag, index) => (
      <span 
        key={index}
        className="text-blue-600 hover:text-blue-700 cursor-pointer text-sm font-medium mr-2"
      >
        {tag}
      </span>
    ));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-white border-b border-gray-200 px-4 py-4">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
            <span className="text-white font-bold text-sm">📰</span>
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Feed Agenzie</h1>
            <p className="text-sm text-gray-600">Scopri opportunità di lavoro</p>
          </div>
        </div>
      </div>

      {/* Feed Content */}
      <div className="max-w-2xl mx-auto px-4 py-6 space-y-6">
        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          posts.map((post) => (
            <Card key={post.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border-0 overflow-hidden">
              <CardContent className="p-0">
                {/* Header del Post */}
                <div className="p-4 pb-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-white rounded-xl border-2 border-gray-100 flex items-center justify-center shadow-sm">
                        <img 
                          src={post.agenzia.logo}
                          alt={post.agenzia.nome}
                          className="w-8 h-8"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = '<span class="text-blue-600 font-bold text-xs">🏢</span>';
                          }}
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <h3 className="font-semibold text-gray-900 truncate">{post.agenzia.nome}</h3>
                        <div className="flex items-center gap-1 text-sm text-gray-600">
                          <MapPin className="w-3 h-3" />
                          <span>{post.agenzia.citta} • {post.agenzia.zona}</span>
                        </div>
                      </div>
                    </div>
                    <span className="text-xs text-gray-500">{post.timestamp}</span>
                  </div>
                </div>

                {/* Contenuto del Post */}
                <div className="px-4 pb-3">
                  <p className="text-gray-800 leading-relaxed mb-3">{post.contenuto.testo}</p>
                  {renderHashtags(post.hashtags)}
                </div>

                {/* Immagine */}
                {post.contenuto.immagine && (
                  <div className="relative">
                    <img 
                      src={post.contenuto.immagine}
                      alt="Post content"
                      className="w-full h-64 object-cover"
                    />
                  </div>
                )}

                {/* Statistiche */}
                <div className="px-4 py-2 border-b border-gray-100">
                  <div className="flex items-center justify-between text-sm text-gray-600">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center gap-1">
                        <Eye className="w-4 h-4" />
                        <span>{post.statistiche.visualizzazioni}</span>
                      </div>
                      <span>{post.statistiche.likes} mi piace</span>
                      <span>{post.statistiche.commenti} commenti</span>
                    </div>
                    <span>{post.statistiche.salvati} salvati</span>
                  </div>
                </div>

                {/* Azioni */}
                <div className="p-4 space-y-3">
                  {/* Pulsanti Interazione */}
                  <div className="flex items-center justify-around">
                    <button
                      onClick={() => handleLike(post.id)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all ${
                        post.liked 
                          ? 'bg-red-50 text-red-600 hover:bg-red-100' 
                          : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      <Heart className={`w-4 h-4 ${post.liked ? 'fill-current' : ''}`} />
                      <span className="text-sm font-medium">Mi piace</span>
                    </button>

                    <button className="flex items-center gap-2 px-4 py-2 rounded-full bg-gray-50 text-gray-600 hover:bg-gray-100 transition-all">
                      <MessageCircle className="w-4 h-4" />
                      <span className="text-sm font-medium">Commenta</span>
                    </button>

                    <button
                      onClick={() => handleSave(post.id)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all ${
                        post.saved 
                          ? 'bg-blue-50 text-blue-600 hover:bg-blue-100' 
                          : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      <Bookmark className={`w-4 h-4 ${post.saved ? 'fill-current' : ''}`} />
                      <span className="text-sm font-medium">Salva</span>
                    </button>
                  </div>

                  {/* CTA Buttons */}
                  <div className="flex gap-3">
                    <Button
                      onClick={() => handleContact(post.agenzia.nome)}
                      variant="outline"
                      className="flex-1 rounded-full border-2 border-blue-600 text-blue-600 hover:bg-blue-50"
                    >
                      <Send className="w-4 h-4 mr-2" />
                      Contatta Agenzia
                    </Button>
                    <Button
                      onClick={() => handleApply(post.agenzia.nome)}
                      className="flex-1 rounded-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white"
                    >
                      <Heart className="w-4 h-4 mr-2" />
                      Candidati Subito
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))
        )}

        {/* Load More Indicator */}
        <div className="text-center py-6">
          <div className="text-gray-500 text-sm">Caricamento nuovi post...</div>
        </div>
      </div>
    </div>
  );
};

export default FeedAgenzie;